import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import Crumb, { CrumbTemplateProps } from '../Crumb';

export default function OrderOverviewCrumb({ current }: CrumbTemplateProps) {
  return (
    <Crumb current={current} text={t(TranslationKey.order).plural.upper} path={Routing.operations.orders.overview()} />
  );
}
